@use 'sass:map';
@use 'ui/styles/core-tokens' as core;

.users {
  &Empty {
    padding: 20px;
    background-color: map.get(core.$buttons, buttonSecondaryDisabled);
  }
}
